/**
 * URL example
 * - https://myinteractive.video/w/thsPNPSjiWGx
 * - https://embed.mindstamp.io/embed/thsPNPSjiWGx
 * - https://video.mindstamp.io/watch/thsPNPSjiWGx
 */
export const MINDSTAMP_URL_REGEX = /^https?:\/\/(.+)?(mindstamp\.io|myinteractive\.video)\/.+\/(.+)$/;
